module.exports = __webpack_public_path__ + "static/media/daysOnboard.885e4585.svg";